import type { TursoReplicaState } from './turso-worker-proxy'

/** Read the binding's current public state through its live subscription. */
export async function readReplicaState(driver: { subscribeReplica?: (listener: (state: TursoReplicaState) => void) => Promise<() => void> }): Promise<TursoReplicaState> {
  if (!driver.subscribeReplica) throw new Error('Native replica state required')
  let state: TursoReplicaState | undefined
  const release = await driver.subscribeReplica(value => { state = value })
  release()
  if (!state) throw new Error('Native replica state required')
  return state
}
